function Megaphone(props) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_5104_10184)" fill="transparent">
        <path
          opacity="0.2"
          d="M13.75 13.75H17.1875C18.0992 13.75 18.9735 13.3878 19.6182 12.7432C20.2628 12.0985 20.625 11.2242 20.625 10.3125C20.625 9.40082 20.2628 8.52648 19.6182 7.88182C18.9735 7.23716 18.0992 6.875 17.1875 6.875H13.75V13.75Z"
          fill="currentColor"
        />
        <path
          d="M13.75 6.875V17.2451C13.7501 17.3581 13.778 17.4695 13.8314 17.5691C13.8848 17.6688 13.9619 17.7538 14.0559 17.8166L15.0012 18.4465C15.0929 18.5076 15.198 18.5458 15.3075 18.5579C15.4171 18.5699 15.5279 18.5554 15.6307 18.5156C15.7335 18.4759 15.8252 18.412 15.8981 18.3294C15.971 18.2467 16.023 18.1478 16.0497 18.0409L17.1875 13.75"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.4375 17.1875C3.43753 17.3184 3.47495 17.4466 3.54535 17.557C3.61575 17.6674 3.71621 17.7554 3.83492 17.8106C3.95362 17.8658 4.08563 17.886 4.21542 17.8688C4.34521 17.8516 4.46739 17.7977 4.56758 17.7134C9.0707 13.9356 13.75 13.75 13.75 13.75H17.1875C18.0992 13.75 18.9735 13.3878 19.6182 12.7431C20.2628 12.0985 20.625 11.2241 20.625 10.3125C20.625 9.40077 20.2628 8.52643 19.6182 7.88178C18.9735 7.23712 18.0992 6.87496 17.1875 6.87496H13.75C13.75 6.87496 9.0707 6.68933 4.56758 2.91238C4.46744 2.82814 4.34535 2.77423 4.21563 2.75698C4.08592 2.73973 3.95398 2.75985 3.8353 2.81499C3.71663 2.87013 3.61616 2.95799 3.5457 3.06826C3.47523 3.17852 3.43769 3.3066 3.4375 3.43746V17.1875Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5104_10184">
          <rect width="22" height="22" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Megaphone;
